/*
If we want more types of error messages we can turn state in too an objekt like this.
state = { setTimeOutErrorMessage: null, persistanErrorMessage: null }. 
Inspired by https://github.com/reactjs/redux/blob/master/examples/real-world/src/reducers/index.js#L16-L27
*/
const initialState = {successMessage: null, errorMessage: null}
export default function messages (state = initialState , action) {
    const { type, errorMessage, successMessage} = action
  
    if (type === "RESET_ERROR_MESSAGES") {
      return initialState
    } else if (errorMessage) {
      return Object.assign({}, state, {errorMessage})
    } else if (successMessage) {
      return Object.assign({}, state, {successMessage})
    }
  
    return state
}


// WEBPACK FOOTER //
// ./src/store/reducers/messages.js